import React from "react";
import { Text } from "react-native";
import { useCustomTheme } from "../hooks/useCustomTheme";
const parseTextWithBold = (text) => {
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, index) => {
        if (part.startsWith("**") && part.endsWith("**")) {
            return {
                text: part.slice(2, -2),
                bold: true,
                key: index,
            };
        }
        return {
            text: part,
            bold: false,
            key: index,
        };
    });
};
export const ThemedTextWithBold = ({ style, textContent, fontDefault, fontBold, }) => {
    const { fonts } = useCustomTheme();
    const parsedText = React.useMemo(() => parseTextWithBold(textContent), [textContent]);
    return (<Text>
      {parsedText.map((part) => (<Text key={part.key} style={[
                style,
                part.bold
                    ? (fontBold ?? fonts.bold)
                    : (fontDefault ?? fonts.regular),
            ]}>
          {part.text}
        </Text>))}
    </Text>);
};
//# sourceMappingURL=ThemedTextWithBold.js.map